<script setup>
import { computed, getCurrentInstance } from 'vue';
import Button from "../../common/Button.vue";

const props = defineProps({
    tableName: {
        type: String,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const component = computed(() => {
    return store.state.components.items.find(o => o.tableName === props.tableName);
});

const user = computed(() => store.state.user.user);

const show = computed(() => {
    if (!user.value || !component.value) return false;

    return (
        user.value.administrator ||
        (user.value.access?.__formAdmin && component.value.navigationGroup === 'Forms')
    );
});

// --- Methods ---

const goToComponentFields = () => {
    // Accessing via proxy to ensure we get the latest route params
    const tableNameParam = proxy.$route.params.component;

    proxy.$router.push({
        name: 'componentFields',
        params: {
            component: tableNameParam
        }
    });
};
</script>

<template>
    <Button v-if="show" @click.native="goToComponentFields">
        <i class="bi-pencil-square me-2"/>
        Fields
    </Button>
</template>

<style scoped>
/* Scoped styles preserved empty */
</style>